import {
  Box,
  Button,
  Center,
  CircularProgress,
  Container,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { FuncButton } from "../../customComponents/components/FuncButton";
import { PageHead } from "../../home/components/PageHead";
import { TableHead } from "../../home/components/TableHead";
import { head } from "../helpers";
import {
  useArticleCategoryDelete,
  useArticleCategoryList,
  useArticleCategorySet,
} from "../hooks";

export const ArticleCategoryListScreen = () => {
  const [activeMarkId, setActiveMarkId] = useState(null);
  const toast = useToast();
  const labelRef = useRef<HTMLInputElement>();
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { ArticleCategoryListLoading, ArticleCategoryList, getArticleCategoryList } =
    useArticleCategoryList();
  const { ArticleCategorySetLoading, getArticleCategorySet } = useArticleCategorySet();
  const { ArticleCategoryDeleteReq, ArticleCategoryDeleteLoading } =
    useArticleCategoryDelete();

  useEffect(() => {
    getArticleCategoryList();
  }, []);

  const loading =
    ArticleCategoryListLoading || ArticleCategorySetLoading || ArticleCategoryDeleteLoading;

  const onClose = () => setModalIsOpen(false);

  const onSubmit = async () => {
    const label = labelRef?.current?.value;
    if (label) {
      const res = await getArticleCategorySet({ id: activeMarkId, label });
      if (res.data.success) {
        toast({
          title: "Марка создана ",
          status: "success",
          duration: 9000,
          isClosable: true,
        });
      }
      getArticleCategoryList();
      setModalIsOpen(false);
    }
  };

  return (
    <>
      <PageHead
        breadCrumbs={<Heading>Категории статей</Heading>}
        onClick={() => {
          setActiveMarkId(null);
          setModalIsOpen(true);
        }}
        linkLabel="Добавить категорию"
      >
        {loading ? (
          <Container height="calc(100vh - 240px)">
            <Spinner position={"absolute"} top="50%" right="50%" size="xl" />
          </Container>
        ) : (
          <TableHead column={head}>
            {ArticleCategoryList.map(({ id, label }) => (
              <Tr key={id}>
                <Td>
                  <Text fontSize="sm" color="#121419">
                    {id}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm" color="#121419">
                    {label}
                  </Text>
                </Td>
                <Td isNumeric>
                  <FuncButton
                    onClick={() => {
                      setActiveMarkId(id);
                      setModalIsOpen(true);
                      setTimeout(() => {
                        labelRef.current.value = label;
                      }, 500);
                    }}
                  >
                    РЕДАКТИРОВАТЬ
                  </FuncButton>
                </Td>
                <Td isNumeric>
                  <Button
                    marginLeft={"20px"}
                    colorScheme="red"
                    onClick={() => {
                      if (window.confirm("Пожалуйста, подтвердите удаление")) {
                        ArticleCategoryDeleteReq({ id }).then(() => {
                          getArticleCategoryList();
                        });
                      }
                    }}
                  >
                    Удалить
                  </Button>
                </Td>
              </Tr>
            ))}
          </TableHead>
        )}
      </PageHead>
      <Modal isOpen={modalIsOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Добавить категорию</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            {loading ? (
              <Center>
                <CircularProgress isIndeterminate />
              </Center>
            ) : (
              <FormControl>
                <FormLabel>Наименование</FormLabel>
                <Input ref={labelRef} placeholder="Наименование" />
              </FormControl>
            )}
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" onClick={onClose}>
              Отменить
            </Button>
            <Button
              disabled={loading}
              colorScheme="blue"
              mr={3}
              onClick={onSubmit}
              marginLeft="20px"
            >
              {activeMarkId ? "Редактировать" : "Создать"}
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
